export const STATUS_COLORS = {
  Neu: "bg-falke-blue/10 text-falke-blue",
  Erstkontakt: "bg-amber-100 text-amber-800",
  Termin: "bg-blue-100 text-blue-800",
  Angebot: "bg-violet-100 text-violet-800",
  Vertrag: "bg-indigo-100 text-indigo-800",
  InUmsetzung: "bg-orange-100 text-orange-800",
  Fertig: "bg-green-100 text-green-800",
  Abgelehnt: "bg-rose-100 text-rose-800",
};

export const STATUS_FLOW = ["Neu", "Erstkontakt", "Termin", "Angebot", "Vertrag", "InUmsetzung", "Fertig", "Abgelehnt"];

export const STUFE_FARBE = {
  Bronze: "from-amber-700 to-amber-900",
  Silber: "from-slate-400 to-slate-600",
  Gold: "from-yellow-400 to-yellow-600",
  Platin: "from-cyan-300 to-cyan-500",
};

export const NOTI_LABELS = {
  approval: "Freigabe",
  coin_gutschrift: "FalkeCoins",
  stufenaufstieg: "Stufenaufstieg",
  provision: "Provision",
  gutschrift: "Gutschrift",
  ticket: "Service",
  abschluss: "Abschluss",
  lead: "Empfehlung",
  versand: "Versand",
};
